import Vue from "vue";
import VueRouter from "vue-router";
import UserType from "@/constants/user_type";

import Home from "@/views/Home.vue";
import Login from "@/views/Login/Login.vue";
import ChangePassword from "@/views/ChangePassword/ChangePassword.vue";
import MyPayslips from "@/views/MyPayslips/MyPayslips.vue";
import MyAccount from "@/views/MyAccount/MyAccount.vue";
import News from "@/views/News/News.vue";
import Roles from "@/views/Roles/Roles.vue";

import Users from "@/views/Users/Users.vue";
import Employees from "@/views/Employees/Employees.vue";
import Worksectors from "@/views/Worksectors/Worksectors.vue";
import Workstations from "@/views/Workstations/Workstations.vue";
import Folders from "@/views/Folders/Folders.vue";
import Legajos from "@/views/Legajos/Legajos.vue";
import LegajoForm from "@/views/Legajos/LegajoForm.vue";

import Dashboard from "@/views/Dashboard/index.vue";
import Settings from "@/views/Settings/index.vue";

//STOCK
// import Warehouses from "@/views/Stock/Warehouses/Warehouses.vue";


import Constant from "@/constants/sections";
import { cryptoUtils } from "@/libs/utils/cryptoUtils";
import { authService } from "@/libs/ws/authService";
import Sucursales from "../views/Sucursales/Sucursales.vue";
import Signings from "../views/Signings/Signings.vue";
import OrgChart from "../views/OrgChart/OrgChart.vue";
import OrgChartForm from "../views/OrgChart/OrgChartForm.vue";
import OrgChartNodeTypes from "../views/OrgChartNodeTypes/OrgChartNodeTypes.vue";
import Payslips from "../views/Payslips/Payslips.vue";


Vue.use(VueRouter);

/**
 * Routes general
 */
const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      guest: true,
    },
  },
  {
    // Pantalla completa sin menu (fullscreen); obligatoria en el primer ingreso
    path: "/change-password",
    name: "ChangePassword",
    component: ChangePassword,
    meta: {
      requiresAuth: true,
      fullscreen: true,
    },
  },
  {
    path: "/",
    redirect: "/" + Constant.SECTION_METRICS,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/" + Constant.SECTION_ROLES,
    name: "Roles",
    component: Roles,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/" + Constant.SECTION_USERS,
    name: "Usuarios",
    component: Users,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/" + Constant.SECTION_METRICS,
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/" + Constant.SECTION_SETTINGS,
    name: "Configuracion",
    component: Settings,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/" + Constant.SECTION_EMPLOYEES,
    name: "Empleados",
    component: Employees,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/" + Constant.SECTION_WORKSTATIONS,
    name: "Sectores de trabajo",
    component: Workstations,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/" + Constant.SECTION_WORKSECTORS,
    name: "Puestos de trabajo",
    component: Worksectors,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/" + Constant.SECTION_ORG_CHART_NODE_TYPES,
    name: "Tipos de puesto",
    component: OrgChartNodeTypes,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/" + Constant.SECTION_FOLDERS,
    name: "Folders",
    component: Folders,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/" + Constant.SECTION_LEGAJOS,
    name: "Legajos",
    component: Legajos,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/" + Constant.SECTION_SIGNINGS,
    name: "Firmas",
    component: Signings,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/" + Constant.SECTION_ORG_CHART,
    name: "Organigrama",
    component: OrgChart,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/" + Constant.SECTION_ORG_CHART + "/:id",
    name: "OrgChartForm",
    component: OrgChartForm,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/" + Constant.SECTION_LEGAJOS + "/:id",
    name: "LegajoForm",
    component: LegajoForm,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/" + Constant.SECTION_MY_PAYSLIPS,
    name: "Mis recibos",
    component: MyPayslips,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/" + Constant.SECTION_MY_ACCOUNT,
    name: "Mi cuenta",
    component: MyAccount,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/" + Constant.SECTION_NEWS,
    name: "Novedades",
    component: News,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/" + Constant.SECTION_PAYSLIPS,
    name: "Recibos de sueldo",
    component: Payslips,
    meta: {
      requiresAuth: true,
    },
  },
  //FACTURACION



  //STOCK
  {
    path: "/" + Constant.SECTION_SUCURSALES,
    name: "Sucursales",
    component: Sucursales,
    meta: {
      requiresAuth: true,
    },
  }

];

// Inicio segun los permisos: el empleado sin acceso al Dashboard entra a "Mis recibos"
function homePath() {
  if (localStorage.getItem("user_type") == "S") return "/" + Constant.SECTION_USERS;
  let access = {};
  try {
    access = cryptoUtils.decrypt(localStorage.getItem("access"), Constant.SECRET_PHRASE) || {};
  } catch (e) {
    access = {};
  }
  if (!(Constant.SECTION_METRICS in access) && Constant.SECTION_MY_PAYSLIPS in access) return "/" + Constant.SECTION_MY_PAYSLIPS;
  return "/" + Constant.SECTION_METRICS;
}

var router = null;
router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!authService.isAuthenticated()) {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else if (authService.mustChangePassword() && to.path != "/change-password") {
      next({ path: "/change-password" });
    } else if (to.path == "/" + Constant.SECTION_METRICS && homePath() != to.path) {
      next({ path: homePath() });
    } else {
      next();
    }
  } else {
    if (authService.isAuthenticated() && to.path == "/login") {
      next({ path: homePath() });
    } else {
      next(); // make sure to always call next()!
    }
  }
});

export default router;
